import { PanelBar, PanelBarProps } from '@progress/kendo-react-layout';
import styled, { css } from 'styled-components';
import theme from '@app/theme';

type AccordionProps = PanelBarProps & {
    flat?: true;
    className?: string;
    headerUnderline?: true;
};

const flatStyles = css`
    & {
        border: none;

        > .k-panelbar-header {
            border: none;

            > .k-link {
                &,
                &:hover,
                &.k-selected,
                &.k-focus {
                    border: none;
                    background: white !important;
                    box-shadow: none;
                    padding: 0 0.71em 0 0;
                    line-height: 2.5em;
                }
            }

            > .k-animation-container > .k-child-animation-container > .k-panelbar-group > .k-panelbar-content {
                border: none;
            }
        }

        > .k-panelbar-content {
            border: none;
        }
    }
`;

export const Accordion = styled(PanelBar as any).attrs<AccordionProps>((props) => ({ className: 'app-accordion' }))`
    &&&.app-accordion {
        font-size: var(--font-size);

        flex: 1 1 auto;

        > .k-panelbar-header {
            height: min-content !important;
            min-height: unset !important;
            cursor: pointer;
            color: ${(props) => props.theme.colors.base_grey};

            > .k-link {
                border-bottom: ${(props) =>
                    props.headerUnderline ? `solid 1px ${props.theme.colors.road_grey_10p} !important` : ''};

                gap: 0.5em;

                &,
                &.k-selected {
                    flex-direction: row-reverse;
                    align-items: center;
                    cursor: pointer;
                    color: ${(props) => props.theme.colors.base_grey};
                }

                > .k-panelbar-item-text {
                    flex: 1 1 auto;
                    display: flex;
                    font-weight: bold;
                    font-size: 0.86em;
                    letter-spacing: 0.036em;
                }

                > .k-panelbar-toggle {
                    color: ${(props) => props.theme.colors.road_grey_700};
                    margin-inline-start: 0;
                    margin: 0;
                    font-size: 1.1em;
                    right: unset;
                }
            }

            & > .k-link > .k-panelbar-toggle:before {
                content: '\\e014';
            }

            &.k-expanded > .k-link > .k-panelbar-toggle:before {
                content: '\\e015';
            }

            > .k-animation-container {
                > .k-child-animation-container {
                    > .k-panelbar-group {
                        .k-panelbar-content:not(:empty) {
                            padding: 0.71em;
                            padding-left: 1.43em;
                        }
                    }
                }
            }
        }

        .k-panelbar-content {
            cursor: default !important;
        }

        ${(props) => props.flat && flatStyles};

        > .k-panelbar-header {
            > .k-link,
            > .k-link:hover,
            > .k-link.k-selected,
            > .k-link.k-focus {
                @container (max-width: ${theme.screen.sm}) {
                    line-height: 2em;
                }
            }
        }
    }
`;
